export default __webpack_public_path__ + "static/media/D016_tn.2e00425a.jpg";